var _combineReducers;

import * as _ from "./util/lodash";
import { combineReducers } from 'redux';
import Form from "./components/core/form";
import ValidatableAssetUploader from "./components/core/asset-uploader/validatable-asset-uploader";
import ValidatableCTADropdown from "./components/abstractions/call-to-action/validatable-cta-dropdown";
import ValidatableColorPicker from "./components/core/color-picker/validatable-color-picker";
import ValidatableDateTimePicker from "./components/core/date-time-picker/validatable-date-time-picker";
import ValidatableDateRangePicker from "./components/core/date-range-picker/validatable-date-range-picker";
import ValidatableInput from "./components/core/input/validatable-input";
import ValidatableTextArea from "./components/core/textarea/validatable-textarea";
import ValidatableRichText from "./components/abstractions/rich-text/validatable-rich-text";
import validatable from "./components/core/hoc/validatable";
import { animatingButtonRedux } from "./components/core/button";
import config from "./config";
/* CK FORM exports */

import Actions from "./components/core/form/actions";
import FormReducer from "./components/core/form/reducer";
import Selectors from "./components/core/form/selectors";
import Validators from "./validators";
export var CKForm = {
  Actions: {
    deregisterForm: Actions.deregisterForm,
    deregisterField: Actions.deregisterField,
    validateForm: Actions.validateForm,
    changeField: Actions.changeField
  },
  Selectors: {
    areFormsValid: Selectors.areFormsValid,
    getFormErrors: Selectors.getFormErrors,
    getFormValues: Selectors.getFormValues,
    isFormValid: Selectors.isFormValid,
    isFormDirty: Selectors.isFormDirty,
    getFieldErrors: Selectors.getFieldErrors
  },
  validatable: validatable,
  ValidatableInput: ValidatableInput,
  ValidatableAssetUploader: ValidatableAssetUploader,
  ValidatableColorPicker: ValidatableColorPicker,
  ValidatableDateTimePicker: ValidatableDateTimePicker,
  ValidatableDateRangePicker: ValidatableDateRangePicker,
  ValidatableCTADropdown: ValidatableCTADropdown,
  ValidatableTextArea: ValidatableTextArea,
  ValidatableRichText: ValidatableRichText,
  Validators: Validators,
  Form: Form
};
export var ckRedux = {
  namespace: 'ck',
  reducer: combineReducers((_combineReducers = {
    form: FormReducer
  }, _combineReducers[animatingButtonRedux.namespace] = animatingButtonRedux.reducer, _combineReducers)),
  sagas: animatingButtonRedux.sagas
};
/* CORE COMPONENTS */

export { FileUploaderStore } from "./components/core/asset-uploader/file-utils";
export { SingleSelect, MultiSelect } from "./components/core/dropdown";
export { default as AdaptiveTooltip } from "./components/core/adaptive-tooltip";
export { Tooltip, tooltipify } from "./components/core/tooltip";
export { default as AssetUploader } from "./components/core/asset-uploader";
export { default as Box } from "./components/core/box";
export { default as Button } from "./components/core/button";
export { default as ButtonMenu } from "./components/core/button-menu";
export { default as Card } from "./components/core/card";
export { default as Chart } from "./components/core/chart";
export { default as Checkbox } from "./components/core/checkbox-like/checkbox";
export { default as CheckboxGroup } from "./components/core/checkbox-group";
export { default as ColorPicker } from "./components/core/color-picker";
export { default as DateTime } from "./components/core/date-time";
export { default as DateTimePicker } from "./components/core/date-time-picker";
export { default as DateRangePicker } from "./components/core/date-range-picker";
export { default as EmptyState } from "./components/core/empty-state";
export { default as ExpandableMenu } from "./components/core/expandable-menu";
export { default as Header } from "./components/core/header";
export { default as Hoverable } from "./components/core/hoverable";
export { default as Icon } from "./components/core/icon";
export { default as IconMenu } from "./components/core/icon-menu";
export { default as Image } from "./components/core/image";
export { default as Input } from "./components/core/input";
export { default as Label } from "./components/core/label";
export { default as Layout } from "./components/core/layout";
export { default as Lozenge } from "./components/core/lozenge";
export { default as Media } from "./components/core/media";
export { default as Menu } from "./components/core/menu";
export { default as Modal } from "./components/core/modal";
export { default as Paging } from "./components/core/paging";
export { default as ProgressBar } from "./components/core/progress-bar";
export { default as Radio } from "./components/core/checkbox-like/radio";
export { default as RadioGroup } from "./components/core/radio-group";
export { default as SimplePopup } from "./components/core/simple-popup";
export { default as Sticky } from "./components/core/sticky";
export { default as Table } from "./components/core/table";
export { default as TabMenu } from "./components/core/tab-menu";
export { default as TextArea } from "./components/core/textarea";
export { default as TextMenu } from "./components/core/text-menu";
export { default as Toggle } from "./components/core/checkbox-like/toggle";
export { default as Video } from "./components/core/video";
/* ABSTRACT COMPONENTS */

export { default as AlignmentMenu } from "./components/abstractions/alignment-menu";
export { default as Animate } from "./components/abstractions/animate";
export { default as AssetRadioMenu } from "./components/abstractions/asset-radio-menu";
export { default as Avatar } from "./components/abstractions/avatar";
export { default as BackgroundMedia } from "./components/abstractions/background-media";
export { default as BaseToolbar } from "./components/abstractions/base-toolbar";
export { default as BigSearch } from "./components/abstractions/big-search";
export { default as Carousel } from "./components/abstractions/carousel";
export { default as CTADropdown } from "./components/abstractions/call-to-action/cta-dropdown";
export { default as CodeMirror } from "./components/abstractions/codemirror";
export { default as ColorSwatch } from "./components/abstractions/color-swatch";
export { default as ContentCard } from "./components/abstractions/content-card";
export { default as ContentItem } from "./components/abstractions/content-item";
export { default as CopyEditor } from "./components/abstractions/copy-editor";
export { default as Counter } from "./components/abstractions/counter";
export { default as DiscardChangesModal } from "./components/abstractions/discard-changes-modal";
export { default as ErrorIcon } from "./components/abstractions/error-icon";
export { default as HighlightText } from "./components/abstractions/highlight-text";
export { default as HighlightTweet } from "./components/abstractions/highlight-tweet";
export { default as IsInvertedProvider } from "./components/abstractions/is-inverted-provider";
export { default as LibrarySelect } from "./components/abstractions/library-select";
export { default as ListItem } from "./components/abstractions/list-item";
export { default as LoadingState } from "./components/abstractions/loading-state";
export { default as MediaSettings } from "./components/abstractions/media-settings";
export { default as Message } from "./components/abstractions/message";
export { default as ModalApplication } from "./components/abstractions/modal-application";
export { default as ModifiedBy } from "./components/abstractions/modified-by";
export { default as Panel } from "./components/abstractions/panel";
export { default as PasswordField } from "./components/abstractions/password-field";
export { default as Picker } from "./components/abstractions/picker";
export { default as PickerModal } from "./components/abstractions/picker-modal";
export { default as Pill } from "./components/abstractions/pill";
export { default as PopupMenu } from "./components/abstractions/popup-menu";
export { default as PromptModal } from "./components/abstractions/prompt-modal";
export { default as QuickAction } from "./components/abstractions/quick-action";
export { default as RichText } from "./components/abstractions/rich-text";
export { default as SaveButtons } from "./components/abstractions/save-buttons";
export { default as Sharing } from "./components/abstractions/sharing";
export { default as SidePane } from "./components/abstractions/side-pane";
export { default as Slider } from "./components/abstractions/slider";
export { default as SocialNetworkSelect } from "./components/abstractions/social-network-select";
export { default as StatusLabel } from "./components/abstractions/status-label";
export { default as StyleVariationSelect } from "./components/abstractions/style-variation-select";
export { default as Timeline } from "./components/abstractions/timeline";
export { default as TextEditor } from "./components/abstractions/text-editor";
export { default as ToggleableControlGroup } from "./components/abstractions/toggleable-control-group";
export { default as Toolbar } from "./components/abstractions/toolbar";
export { default as Truncate } from "./components/abstractions/truncate";
export { default as Wizard } from "./components/abstractions/wizard";
export { default as createComponent } from "./wayin-react/component-factory";
export { default as PropTypes } from "./wayin-react/prop-types";
import * as _enums from "./enums";
export { _enums as enums };
export { default as Bootstrapper } from "./bootstrapper";
export { TextTransformService } from "./services";
export { html as HTMLUtils } from "./util";
export { asset as AssetUtils } from "./util";

_.noConflict();

config.init();
//# sourceMappingURL=index.js.map